
import { useLocation } from "react-router-dom";
var apiBaseURL = process.env.REACT_APP_API_PATH;

export const updateAPIData = async (_url, data) => {
  var response;
  var obj = data;
  const url = apiBaseURL + _url;

  try {
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(obj),
    });


  } catch (error) {
    console.log("error", error);

  } finally {

    if (response.status > 400) {
      return { "message": response.statusText }
    }
    else {
      return { "message": "success" }
    }
  }

}


export const postData = async (url = '', data = {}) => {
  console.log("CALL POST DATA---", url,data);
      const location = window.location.pathname;

// const token = location.includes("studio/galleries")
//   ? localStorage.getItem('authToken')
//   : localStorage.getItem('token');

const token = localStorage.getItem('authToken');

  try {



    const response = await fetch(apiBaseURL + url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })  // ✅ Fix here
      },
      body: JSON.stringify(data)
    });

    const res = await response.json();
    return res;

  } catch (error) {
    console.error('Error:', error);
  }
};


export const getData = async (url = '', data = '') => {

  console.log("DATA ",url)
const location = window.location.pathname;

const token = (location.includes("login") || location.includes("studio") || location.includes("checkout") || location.includes("success"))
  ? localStorage.getItem('authToken')
  : localStorage.getItem('token');

  

 
  var response = null;
  // Default options are marked with *
  response = await fetch(apiBaseURL+url + '?' + data, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })  // ✅ Fix here
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  return response.json()

}


export const putData = async (url = '', data = {}) => {

  console.log("CALL POST DATA---",data)
 const location = window.location.pathname;

const token = (location.includes("studio") || location.includes("checkout") || location.includes("success"))
  ? localStorage.getItem('authToken')
  : localStorage.getItem('token');


  try {
    const response = await fetch(apiBaseURL+url, {
        method: 'PUT',
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify(data)
    });

    const res = await response.json();
    return res;
     
} catch (error) {
    console.error('Error:', error);
}
}

export const deleteData = async (url = '', data = '') => {

    const location = window.location.pathname;

const token = (location.includes("studio") || location.includes("checkout") || location.includes("success"))
  ? localStorage.getItem('authToken')
  : localStorage.getItem('token');


  var response = null;
  // Default options are marked with *+ '?' + data
  response = await fetch(apiBaseURL+url , {
    method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json'
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: 'follow', // manual, *follow, error
    referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
  });
  return response.json()

}

  export const getPresignedUrl = async (folderId,folderPath) => {
   

    const response = await fetch(folderPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        file_name: `${folderId} }`,
      }),
    });

    return response.json();
};
  

/*
const waitForImage = async (url, retries = 10, delay = 1000) => {
  for (let i = 0; i < retries; i++) {
    const exists = await checkImageExists(url);
    if (exists) return true;

    await new Promise((res) => setTimeout(res, delay));
  }
  return false;
};

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
    });
  };
const handleImageProcessing = async (photoId, filePath) => {
  const fullUrl = `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${filePath}`;

  // start processing
  setProcessingPhotos((prev) => ({
    ...prev,
    [photoId]: true,
  }));

  // wait for image
  await waitForImage(fullUrl);

  // update version (cache bust)
  setImageVersion((prev) => ({
    ...prev,
    [photoId]: Date.now(),
  }));

  // stop processing
  setProcessingPhotos((prev) => {
    const updated = { ...prev };
    delete updated[photoId];
    return updated;
  });
};*/